module.exports = __webpack_public_path__ + "media/images/lab-40eaaa71899007b36616de98870f1ae1.png";